import React, { isValidElement } from 'react';
import { Transition } from 'react-transition-group';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultTransitionStyles = {
  entering: {},
  entered: {},
  exiting: {},
  exited: {},
  unmounted: {}
};
const TransitionBase = (_a) => {
  var _b = _a, {
    children,
    in: inProp,
    timeout = 0,
    transitionStyles = defaultTransitionStyles,
    transitionProperties = "opacity"
  } = _b, props = __objRest(_b, [
    "children",
    "in",
    "timeout",
    "transitionStyles",
    "transitionProperties"
  ]);
  const child = React.Children.only(children);
  if (!isValidElement(child)) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, child);
  }
  const transitionPropertiesArray = typeof transitionProperties === "string" ? [transitionProperties] : transitionProperties;
  return /* @__PURE__ */ React.createElement(Transition, __spreadValues({
    appear: true,
    in: inProp,
    timeout
  }, props), (state, childProps) => React.cloneElement(child, __spreadValues({
    style: __spreadValues(__spreadValues({
      visibility: state === "exited" && !inProp ? "hidden" : void 0,
      transition: transitionPropertiesArray.map((property) => `${property} ${timeout}ms ease-in-out`)
    }, transitionStyles[state]), child.props.style)
  }, childProps)));
};

export { TransitionBase };
//# sourceMappingURL=TransitionBase.es.js.map
